import { INVENTORY_FILTER_COLORS } from '@/catalog/utils/is-inventory-filter-color';
import { cn } from '@/shadcn-ui/utils';
import { colors } from '@/theme/colors';

function colorSwatchFill(color: string) {
  return INVENTORY_FILTER_COLORS[color] ? INVENTORY_FILTER_COLORS[color] : 'gradient';
}

interface ColorSwatchProps {
  color: string;
  className?: string;
}

export default function ColorSwatch({ color, className }: ColorSwatchProps) {
  const fill = colorSwatchFill(color);

  if (fill === 'gradient') {
    // Note: The SVG code generated by Figma was a radial gradient instead of a conic gradient so we need to manually create the conic gradient ourselves with a div.
    return (
      <div
        className={cn(
          'h-[16px] w-[16px] rounded-full bg-[conic-gradient(from_180deg_at_50%_50%,_#E900EC_0deg,_#00FFCD_127.79999613761902deg,_#4249FF_248.39999914169312deg,_#E900EC)]',
          className
        )}
      />
    );
  }

  if (fill === colors.neutral100) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        fill="none"
        className={cn('h-[16px] w-[16px]', className)}
      >
        <circle
          cx="8"
          cy="8"
          r="7.5"
          stroke={colors.neutral80}
          fill={colorSwatchFill(color)}
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      className={cn('h-[16px] w-[16px]', className)}
    >
      <circle cx="8" cy="8" r="8" fill={fill} />
    </svg>
  );
}
